<div class="container-fluid">
  <!-- start page title -->
  <app-pagetitle title="Devices" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
</div>

<div class="row d-flex justify-content-between align-items-center">
  <div class="form-group col-md-3">
    <label class="control-label">MachineType</label>
    <select class="form-control" name="configType" id="configType" [(ngModel)]="selectedconfigType"
      (change)="configtypeChange($event.target.value)">
      <!-- <option value="" selected disabled>Select Machine</option> -->
      <option value="parts">With_Parts</option>
      <option value="noparts">Without_Parts</option>
      <option value="cycletime">With_CyclTime</option>
    </select>
  </div>

  <div class="col-md-3 d-flex justify-content-end">
    <button class="btn btn-primary" title="Back" (click)="goBack()">
      Back
    </button>
  </div>
</div>

<div class="card p-3" *ngIf="selectedconfigType == 'parts'">
  <h4>Availability Formula</h4>
  <div class="container mt-3">
      <h5>Numerator (Machine Available Time)</h5>
    <div class="d-block d-sm-flex flex-wrap">
      <div class="form-check" *ngFor="let key of objectKeys(availabilityNumerator)">
        <input type="checkbox" class="form-check-input" [(ngModel)]="availabilityNumerator[key]" [name]="'nom-' + key"
          [id]="'nom-' + key" />
        <label class="form-check-label" [for]="'nom-' + key">{{ key }}</label>&nbsp;&nbsp;
      </div>
    </div>
  <h5 class="mt-1">Denominator (ShiftTime)</h5>
    <div class="d-block d-sm-flex flex-wrap">
      <div class="form-check" *ngFor="let key of objectKeys(availabilityDenominator)">
        <input type="checkbox" class="form-check-input" [(ngModel)]="availabilityDenominator[key]" [name]="'den-' + key"
          [id]="'den-' + key" />
        <label class="form-check-label" [for]="'den-' + key">{{ key }}</label>&nbsp;&nbsp;
      </div>
    </div>
    <div class="mt-3 text-danger" *ngIf="formError">{{ formError }}</div>
    <button class="btn btn-primary mt-2" (click)="openModalRest(resetFormula)">Save</button>
  </div>
  <div class="mt-3">
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">
      <p style="font-size: 16px">
        <b>Availability</b> = <b><span style="color: #000000;">( Machine Available Time / Shift Time )</span></b> × 100
      </p>
      <strong style="font-size: 16px">Formula Preview:</strong>
      <div class="container">
        <p style="font-size: 16px"><b><span style="color: #000000;">Machine Available Time = {{ availformulaNumerator
              }}</span></b></p>
        <p style="font-size: 16px"><b><span style="color: #000000;">Shift Time = {{ availformulaDenominator
              }}</span></b></p>
      </div>
    </div>
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">
      <p style="font-size: 16px">
        <b>Performance</b> = ( Part Produced / PlannedPart ) × 100
      </p>
    </div>
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">
      <p style="font-size: 16px">
        <b>Quality</b> = (( Part Produced - PartRejected ) / Part Produced ) × 100
      </p>
    </div>
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">
      <p style="font-size: 16px">OEE = Availability × Performance × Quality</p>
    </div>
  </div>
</div>

<div class="card p-3" *ngIf="selectedconfigType == 'noparts'">
  <h4>Availability Formula</h4>
  <div class="container mt-1">
    <h5>Numerator (Machine Available Time)</h5>
    <div class="d-block d-sm-flex flex-wrap">
      <div class="form-check" *ngFor="let key of objectKeys(availabilityNumerator)">
        <input type="checkbox" class="form-check-input" [(ngModel)]="availabilityNumerator[key]"
          [name]="'availnom-' + key" [id]="'availnom-' + key" />
        <label class="form-check-label" [for]="'availnom-' + key">{{
          key
          }}</label>&nbsp;&nbsp;
      </div>
    </div>

    <h5 class="mt-1">Denominator (ShiftTime)</h5>
    <div class="d-block d-sm-flex flex-wrap">
      <div class="form-check" *ngFor="let key of objectKeys(availabilityDenominator)">
        <input type="checkbox" class="form-check-input" [(ngModel)]="availabilityDenominator[key]"
          [name]="'availden-' + key" [id]="'availden-' + key" />
        <label class="form-check-label" [for]="'availden-' + key">{{
          key
          }}</label>&nbsp;&nbsp;
      </div>
    </div>
    <div class="mt-3 text-danger" *ngIf="formError">{{ formError }}</div>
  </div>
  <h4>Performance Formula</h4>
  <div class="container mt-1">
    <h5>Numerator</h5>
    <div class="d-block d-sm-flex flex-wrap">
      <div class="form-check" *ngFor="let key of objectKeys(performanceNumerator)">
        <input type="checkbox" class="form-check-input" [(ngModel)]="performanceNumerator[key]"
          [name]="'perfnom-' + key" [id]="'perfnom-' + key" />
        <label class="form-check-label" [for]="'perfnom-' + key">{{
          key
          }}</label>&nbsp;&nbsp;
      </div>
    </div>

    <!-- <h5 class="mt-1">Denominator Parameters</h5>
    <div class="d-block d-sm-flex flex-wrap">
      <div class="form-check" *ngFor="let key of objectKeys(performanceDenominator)">
        <input type="checkbox" class="form-check-input" [(ngModel)]="performanceDenominator[key]"
          [name]="'perfden-' + key" [id]="'perfden-' + key" />
        <label class="form-check-label" [for]="'perfden-' + key">{{
          key
          }}</label>&nbsp;&nbsp;
      </div>
    </div> -->
    <div class="mt-3 text-danger" *ngIf="formError2">{{ formError2 }}</div>
    <button class="btn btn-primary mt-2" (click)="openModalRest(resetFormula)">Save</button>
  </div>

  <div class="mt-3">
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">
      <p style="font-size: 16px">
        <b>Availability</b> = <b><span style="color: #000000;">( Machine Available Time / Shift Time )</span></b> × 100
      </p>
      <strong style="font-size: 16px">Formula Preview:</strong>
      <div class="container">
        <p style="font-size: 16px"><b><span style="color: #000000;">Machine Available Time = {{ availformulaNumerator
              }}</span></b></p>
        <p style="font-size: 16px"><b><span style="color: #000000;">Shift Time = {{ availformulaDenominator
              }}</span></b></p>
      </div>
    </div>
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">

      <p style="font-size: 16px">
        <b>Performance</b> = <b><span style="color: #000000;">( {{perfformula}} / Machine Available Time )</span></b> ×
        100
      </p>
      <strong style="font-size: 16px">Formula Preview:</strong>
      <p style="font-size: 16px"><b><span style="color: #000000;">Machine Available Time = {{ availformulaNumerator
            }}</span></b></p>
    </div>
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">
      <p style="font-size: 16px">
        <b>Quality</b> = 100
      </p>
    </div>
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">
      <p style="font-size: 16px">OEE = Availability × Performance × Quality</p>
    </div>
  </div>
</div>

<div class="card p-3" *ngIf="selectedconfigType == 'cycletime'">
  <h4>Formula Parameters</h4>
  <div class="container mt-1">
  <h5>Numerator (Machine Available Time)</h5>
    <div class="d-block d-sm-flex flex-wrap">
      <div class="form-check" *ngFor="let key of objectKeys(availabilityNumerator)">
        <input type="checkbox" class="form-check-input" [(ngModel)]="availabilityNumerator[key]"
          [name]="'availnom-' + key" [id]="'availnom-' + key" />
        <label class="form-check-label" [for]="'availnom-' + key">{{
          key
          }}</label>&nbsp;&nbsp;
      </div>
    </div>

<h5 class="mt-1">Denominator (ShiftTime)</h5>
    <div class="d-block d-sm-flex flex-wrap">
      <div class="form-check" *ngFor="let key of objectKeys(availabilityDenominator)">
        <input type="checkbox" class="form-check-input" [(ngModel)]="availabilityDenominator[key]"
          [name]="'availden-' + key" [id]="'availden-' + key" />
        <label class="form-check-label" [for]="'availden-' + key">{{
          key
          }}</label>&nbsp;&nbsp;
      </div>
    </div>
    <div class="mt-3 text-danger" *ngIf="formError">{{ formError }}</div>
        <button class="btn btn-primary mt-2" (click)="openModalRest(resetFormula)">Save</button>
  </div>
  <!-- <h4>Performance Formula</h4>
  <div class="container mt-1">
    <h5>Numerator Parameters</h5>
    <div class="d-block d-sm-flex flex-wrap">
      <div class="form-check" *ngFor="let key of objectKeys(performanceNumerator)">
        <input type="checkbox" class="form-check-input" [(ngModel)]="performanceNumerator[key]"
          [name]="'perfnom-' + key" [id]="'perfnom-' + key" />
        <label class="form-check-label" [for]="'perfnom-' + key">{{
          key
          }}</label>&nbsp;&nbsp;
      </div>
    </div>
    <div class="mt-3 text-danger" *ngIf="formError2">{{ formError2 }}</div>
    <button class="btn btn-primary mt-2" (click)="openModalRest(resetFormula)">Save</button>
  </div> -->

  <div class="mt-3">
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">
      <p style="font-size: 16px">
        <b>Availability</b> = <b><span style="color: #000000;">( Machine Available Time / Shift Time )</span></b> × 100
      </p>
      <strong style="font-size: 16px">Formula Preview:</strong>
      <div class="container">
        <p style="font-size: 16px"><b><span style="color: #000000;">Machine Available Time = {{ availformulaNumerator
              }}</span></b></p>
        <p style="font-size: 16px"><b><span style="color: #000000;">Shift Time = {{ availformulaDenominator
              }}</span></b></p>
      </div>
    </div>

    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">
      <p style="font-size: 16px"><b>Performance</b> = (Part Produced / (<b><span style="color: #000000;">Machine
            Available Time</span></b> / CycleTime ))
        × 100</p>
      <strong style="font-size: 16px">Formula Preview:</strong>
      <div class="container">
        <p style="font-size: 16px"><b><span style="color: #000000;">Machine Available Time = {{ availformulaNumerator
              }}</span></b></p>
      </div>
    </div>
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">

      <p style="font-size: 16px">
        <b>Quality</b> = (( Part Produced - PartRejected ) / Part Produced ) × 100
      </p>
    </div>
    <div style="border: 1px solid #5e5757; padding: 10px; border-radius: 5px; margin-top: 10px;">

      <p style="font-size: 16px"><b>OEE</b> = Availability × Performance × Quality</p>
    </div>

  </div>
</div>


<ng-template #resetFormula role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Change Formula</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <form>
        <div>
          <p>Are you sure to change the Formula?</p>
        </div>
        <button type="submit" class="btn btn-danger round waves-effect headr" (click)="onSubmit()">
          Ok
        </button>
        &nbsp;
        <button type="submit" class="btn btn-info round waves-effect headr" (click)="modal('Cross click')">
          Cancel
        </button>
      </form>
    </div>
  </div>
</ng-template>
